import {
    FETCH_ORDER_DETAILS_SUCCESS,
    SELECT_PRODUCT_COLOUR,
    SELECT_RETURN_CODE,
    CLEAR_RETURN,
    CREATE_RETURN_SUCCESS,
    FETCH_ORDER_HISTORY_REQUEST,
    SELECT_RETURN_OR_EXCHANGE,
} from '../constants/ActionTypes'

export default function orderDetails(state = {}, action) {
    switch (action.type) {
        case FETCH_ORDER_DETAILS_SUCCESS:
            return action.order
        case SELECT_RETURN_OR_EXCHANGE:
            if (state.orderItem) {
                const orderItems = state.orderItem.map((item) => {
                    return item.primeLineNo === action.lineNumber
                        ? {
                              ...item,
                              returnOrExchange: action.returnOrExchange,
                          }
                        : item
                })
                return { ...state, orderItem: orderItems }
            } else {
                return state
            }
        case CLEAR_RETURN:
            if (state.orderItem) {
                const orderItems = state.orderItem.map((item) => {
                    return item.primeLineNo === action.item.primeLineNo
                        ? {
                              ...item,
                              returnOrExchange: undefined,
                              selectedReturnCode: undefined,
                              selectedProductColour: undefined,
                          }
                        : item
                })

                return { ...state, orderItem: orderItems }
            } else {
                return state
            }
        case SELECT_RETURN_CODE:
            if (state.orderItem) {
                const orderItems = state.orderItem.map((item) => {
                    return item.primeLineNo === action.lineNumber
                        ? {
                              ...item,
                              selectedReturnCode: action.returnCode,
                          }
                        : item
                })
                return { ...state, orderItem: orderItems }
            } else {
                return state
            }
        case SELECT_PRODUCT_COLOUR:
            if (state.orderItem) {
                const orderItems = state.orderItem.map((item) => {
                    return item.primeLineNo === action.lineNumber
                        ? {
                              ...item,
                              selectedProductColour: action.productColour,
                          }
                        : item
                })
                return { ...state, orderItem: orderItems }
            } else {
                return state
            }
        case CREATE_RETURN_SUCCESS:
            return { ...state, returnSuccess: true, newReturnOrExchangeId: action.newReturnOrExchangeId }
        case FETCH_ORDER_HISTORY_REQUEST:
            return {}
        default:
            return state
    }
}
